module.exports = __webpack_public_path__ + "static/media/righttorent.4ca029fa.png";